import { ArrowRight, Wand2 } from 'lucide-react';
import './LandingAnimations.css';
import { useSettings } from '../settings';

const WORDS = [
  { key: 'landing.diveReady' },
  { key: 'landing.diveTo' },
  { key: 'landing.diveIn', accent: true },
];

export default function DiveInSection({ onStartProject }) {
  const { t } = useSettings();
  return (
    <section id="divein-section" className="scroll-scene">
      <h2 className="divein-headline" aria-label={t('landing.diveLabel')}>
        {WORDS.map(({ key, accent }) => (
          <span
            key={key}
            className={`divein-word${accent ? ' accent' : ''}`}
            aria-hidden="true"
          >
            {t(key)}
          </span>
        ))}
      </h2>

      <p className="divein-subtitle">
        {t('landing.diveCopy')}
      </p>

      <div className="divein-actions">
        <button
          type="button"
          className="divein-cta-btn"
          onClick={onStartProject}
          id="divein-start-btn"
        >
          <Wand2 size={18} strokeWidth={2} />
          {t('landing.diveCta')}
          <ArrowRight size={18} strokeWidth={2} />
        </button>
      </div>
    </section>
  );
}
